import { get } from '../../webapi';
import { SearchResult, SearchCategory } from '../../Model/core';

export const itemLength = 20;

export async function search(term: string, page = 0, cat?: SearchCategory, length = itemLength) {
    let url = `/blApi/search?query=${term}&page=${page}&length=${length}`;

    if (cat != null) {
        url += `&cat=${cat}`;
    }

    return get<SearchResult>(url);
}